<template>
  <section class="block block--connect" id="HeaderWhite">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-12 align-self-center">
          <div class="block__title">
            <HelpersSpotCircle />
            <div class="block__text">READY TO</div>
            <div class="block__highlight">CONNECT ?</div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-12">
          <a :href="localePath('/contact-us')">
            <div class="block__circle">
              <div class="block__wrapper">
                <div class="block__slide" ref="textContainer">
                  <div class="block__list">SUCCESS</div>
                  <div class="block__list">IDEA</div>
                  <div class="block__list">CUSTOMER</div>
                  <div class="block__list">BUSINESS</div>
                  <div class="block__list">SALES</div>
                </div>
              </div>
              <div class="block__link">
                Let’s start the project <i class="icon-arrow-button"></i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const textContainer = ref(null);
let currentY = 0;
let intervalId = null;

const scrollText = () => {
  const containerHeight = textContainer.value.parentNode.offsetHeight;
  const textHeight = textContainer.value.scrollHeight;
  const lineHeight = textContainer.value.firstChild.offsetHeight; // ความสูงของ 1 บรรทัด

  currentY -= lineHeight; // เลื่อนทีละบรรทัด

  if (Math.abs(currentY) + containerHeight >= textHeight) {
    currentY = 0; // เมื่อถึงบรรทัดสุดท้ายให้กลับไปบนสุด
  }

  textContainer.value.style.transform = `translateY(${currentY}px)`;
};

onMounted(() => {
  intervalId = setInterval(scrollText, 1000); // เรียกใช้งานฟังก์ชัน scrollText ทุกๆ 1 วินาที
});

onBeforeUnmount(() => {
  clearInterval(intervalId); // เคลียร์ interval เมื่อคอมโพเนนต์ถูกทำลาย
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .block {
      &.block--connect {
        .block__title {
          @include font-size("display-3", $lang);
          @include font-weight("bold", $lang);
          line-height: 1;

          @include media-breakpoint-down(lg) {
            @include font-size("h1", $lang);
          }
          @include media-breakpoint-down(sm) {
            @include font-size("h3", $lang);
          }
        }

        .block__highlight {
          @include font-family("highlight", $lang);
        }

        .block__list {
          @include font-size("h4", $lang);
          @include font-weight("regular", $lang);
        }

        .block__link {
          @include font-size("body", $lang);
          @include font-weight("medium", $lang);
        }
      }
    }
  }
}

.block {
  &.block--connect {
    position: relative;
    z-index: 1;
    background: linear-gradient(
      180deg,
      rgba($yellow-ci-2, 0) 0%,
      $yellow-ci 66.5%,
      $orange 99.99%,
      $orange 100%
    );
    color: $black;
    padding: 10rem 0;

    @include media-breakpoint-down(lg) {
      padding: 4rem 0;
    }

    .block__title {
      overflow: hidden;

      @include media-breakpoint-down(lg) {
        text-align: center;
        margin-bottom: 3rem;
      }
    }

    .block__highlight {
      font-style: italic;
      padding-left: 5rem;

      @include media-breakpoint-down(lg) {
        padding-left: 0;
      }
    }

    .block__circle {
      width: 320px;
      height: 320px;
      border-radius: 320px;
      border: 1px solid $black;
      color: $black;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @include transition(0.3s);

      @include hover {
        background-color: $white;
        color: $black;
        transform: translate(-7px, -4px);
        border: 0;
      }

      @include media-breakpoint-down(lg) {
        margin-left: auto;
        margin-right: auto;
      }
    }
    .block__wrapper {
      width: 100%;
      height: 80px; /* ความสูงของ 1 บรรทัด */
      overflow: hidden;
      position: relative;
      text-align: center;
    }
    .block__slide {
      position: absolute;
      top: 0;
      width: 100%;
      transition: transform 0.5s ease-in-out; /* สมูทขึ้น */
    }

    .block__list {
      padding: 0.5rem 0;
    }

    .block__subtitle {
      i {
        font-size: px-to-rem(16);
        margin-left: 0.25rem;
      }
    }
  }
}
</style>